function getVersion() {
  const version = import.meta.env.VITE_APP_VERSION;
  return version?.replace(/-/g, ".") ?? "???";
}

export const VERSION = getVersion();

window.VERSION = VERSION;
